import React from 'react';
import { Newshub } from './component';

import polyglotProvider from "./service/translation/polyglotProvider";

const App = () => (
    <Newshub
        i18nProvider={polyglotProvider()}
    />
);

export default App;
